/**
 * /passerelle-a2-a-progression — Trame pédagogique Passerelle A2 → A (7 h).
 * Consolider l’expérience A2 pour accéder à une moto plus performante.
 */
import React from 'react';
import TrameProgression from '../components/trames/TrameProgression';
import TrameLivretCross from '../components/trames/TrameLivretCross';
import { INTRO_PASSERELLE, PHASES_PASSERELLE, buildSynthesePasserelle } from '../data/passerelleA2AProgression';

export default function PasserelleA2AProgression() {
  return (
    <>
      <TrameLivretCross
        current="trame"
        trameTo="/passerelle-a2-a-progression"
        trameLabel="Trame pédagogique Passerelle A2 → A"
        livretTo="/livret-passerelle-a2-a"
        livretLabel="Livret Passerelle A2 → A interactif"
      />
      <TrameProgression
        testid="passerelle-a2-a-progression"
        trameKey="passerelle"
        title="Passerelle A2 → A — Consolider son expérience et accéder à une moto plus performante"
        subtitle="La passerelle A2 → A ne reprend pas la formation A2 : elle s’appuie sur l’expérience acquise, et les exercices sont sélectionnés par l’enseignant selon les besoins réels du conducteur."
        badge="Trame pédagogique Passerelle A2 → A"
        breadcrumbLabel="Passerelle A2 → A · 7 h"
        intro={INTRO_PASSERELLE}
        phases={PHASES_PASSERELLE}
        buildSynthese={buildSynthesePasserelle}
      />
    </>
  );
}
